export const APP_CONFIG = {
    app: {
        name: 'B1 Recharge'
    },
    company: {
        name: 'B1 RECHARGE PRIVATE LIMITED'
    },
    contacts: {
        call: '7896296717',
        whatsapp: 'https://wa.me/917896296717',
        email: 'b1recharge.in@gmail.com'
    },
    urls: {
        web_app_url: 'https://m.b1recharge.in',
        website: 'https://b1recharge.in',
        api_url: 'https://b1recharge.in/api/',
        terms: 'https://b1recharge.in/policy.html?tab=terms',
        privacy: 'https://b1recharge.in/policy.html?tab=privacy',
        refund: 'https://b1recharge.in/policy.html?tab=refund',
        cancellation: 'https://b1recharge.in/policy.html?tab=cancellation',
        deletion: 'https://b1recharge.in/policy.html?tab=deletion',
    },
    colors: {
        bgColor: '#ffffff',                // Deep navy background
        primaryColor: '#133dfd',           // UNCHANGED - Vivid blue
        primaryLight: '#3A62FF',           // Lighter blue for accents/hover
        primaryDark: '#0A2BB8',            // Darker blue
        textPrimary: '#18122b',
        textSecondary: '#6b7280',
        textOnPrimary: '#ffffff',
        borderColor: '#e5e1f2',
        errorColor: '#ef4444',
        surfaceColor: '#f7f5fc',
        borderRadius: 14,
    },
    socialLinks: {
        facebook: '',
        instagram: '',
        youtube: ''
    }
};